export default __webpack_public_path__ + "static/media/vkbg3.42665852.svg";